export default {
    namespaced: true,
    state: {
        name: 'VehicleParkEstimateType',
		endpoint: '/vehicle/park/estimate/type',
        items: [],
    },
}